var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 76,
    viewBox: "0 0 256 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 18,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 17.7333H21.5187V58.2341H38.3281V17.7333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1557_5525)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 18,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 17.7333H21.5187V58.2341H38.3281V17.7333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1557_5525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5187 17.7333V58.2666L38.3281 29.6529L21.5187 17.7333Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 17,
    width: 18,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.651 17.7333H61.8416V58.2341H78.651V17.7333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1557_5525)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 17,
    width: 18,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.651 17.7333H61.8416V58.2341H78.651V17.7333Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1557_5525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8416 29.6529L78.6183 58.2666V17.7333L61.8416 29.6529Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 9,
    width: 24,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8416 9.64612H38.3281V38H61.8416V9.64612Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1557_5525)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 9,
    width: 24,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8416 9.64612H38.3281V38H61.8416V9.64612Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1557_5525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8416 29.653L50.0685 9.64612L38.3281 29.653L50.0685 38L61.8416 29.653Z",
    fill: "#1799D5"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5187 58.2666H78.6183L50.0685 37.9999L21.5187 58.2666Z",
    fill: "#1799D5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 29,
    width: 29,
    height: 30
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6183 29.653H50.0685V58.2342H78.6183V29.653Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1557_5525)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 29,
    width: 29,
    height: 30
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6183 29.653H50.0685V58.2342H78.6183V29.653Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1557_5525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0685 38L78.6183 58.2666L61.8416 29.653L50.0685 38Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 30,
    height: 30
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0685 29.653H21.5187V58.2342H50.0685V29.653Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1557_5525)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1557_5525",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 30,
    height: 30
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0685 29.653H21.5187V58.2342H50.0685V29.653Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1557_5525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 29.653L21.5187 58.2666L50.0685 38L38.3281 29.653Z",
    fill: "#1799D5"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6183 62.294H21.5187V66.3538H78.6183V62.294Z",
    fill: "#1799D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.734 3.31281H100.137V72.6872H103.734V3.31281Z",
    fill: "#CBD2DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.24 46.1846H131.27L128.392 54.8564H122.015L134.017 20.9812H140.493L152.495 54.8564H146.118L143.24 46.1846ZM137.255 26.8598C137.255 26.8598 136.47 30.2051 135.816 32.1214L132.775 41.1829H141.703L138.661 32.1214C138.04 30.2051 137.32 26.8598 137.32 26.8598H137.222H137.255Z",
    fill: "#15284B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.601 20.9812H161.652V46.3795C161.652 49.0427 162.567 49.7248 164.137 49.7248C165.707 49.7248 165.053 49.6923 165.053 49.6923V54.9863C165.053 54.9863 164.137 55.1162 163.123 55.1162C159.755 55.1162 155.569 54.2718 155.569 47.2889V21.0137L155.601 20.9812Z",
    fill: "#15284B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.566 20.9812H175.616V26.3727H169.566V20.9812ZM169.566 30.5299H175.681V54.8564H169.566V30.5299Z",
    fill: "#15284B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M191.673 59.7282C195.434 59.7282 198.606 58.1692 198.606 53.8171V52.388C198.606 51.8034 198.704 51.0889 198.704 51.0889H198.606C197.167 53.2325 195.041 54.3692 191.771 54.3692C184.773 54.3692 180.783 48.7504 180.783 42.0598C180.783 35.3692 184.576 29.9453 191.64 29.9453C198.704 29.9453 198.9 33.0308 198.9 33.0308H199.031C199.031 33.0308 198.999 32.7385 198.999 32.3487V30.4975H204.722V53.3624C204.722 61.7094 198.181 64.8598 191.804 64.8598C185.427 64.8598 185.459 64.0154 183.105 62.7487L184.936 58.1043C184.936 58.1043 188.01 59.6633 191.706 59.6633L191.673 59.7282ZM198.737 42.1248C198.737 36.6034 195.99 35.1094 192.687 35.1094C189.384 35.1094 186.931 37.7727 186.931 41.8974C186.931 46.0222 189.155 49.3026 193.079 49.3026C197.004 49.3026 198.737 47.6462 198.737 42.1573V42.1248Z",
    fill: "#15284B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M211.426 30.5299H217.28V33.3556C217.28 34.265 217.181 35.012 217.181 35.012H217.28C218.326 32.9658 221.04 29.9453 225.979 29.9453C230.917 29.9453 234.481 32.771 234.481 39.2017V54.8564H228.431V40.4359C228.431 37.4804 227.679 35.4667 224.54 35.4667C221.4 35.4667 218.882 37.5128 217.966 40.4359C217.639 41.4427 217.541 42.547 217.541 43.6838V54.8564H211.426V30.5299Z",
    fill: "#15284B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.32aa60194fe6f5493a019bb2a69185f4.svg";
export { ForwardRef as ReactComponent };